import Layout from '@/layout'

const route = {
  path: '/providerAccountManagement',
  component: Layout,
  redirect: '/providerAccountManagement/servicePorviderList/index',
  alwaysShow: true, // will always show the root menu
  name: 'ProviderAccountManagement',
  meta: {
    title: '账号管理',
    icon: 'AccountManage',
    roles: [
      'account_management.relation'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/providerAccountManagement/servicePorviderList/index',
      component: () => import('@/views/providerAccountManagement/servicePorviderList/index.vue'),
      name: 'ServicePorviderList',
      meta: {
        title: '服务商列表',
        icon: 'component',
        roles: [
          'service_providers.index'
        ]
      }
    },
    // 关系绑定
    {
      path: '/adminAdvertMangement/index',
      component: () => import('@/views/providerAccountManagement/adminAdvertMangement/index.vue'),
      name: 'AdminAdvertMangement',
      meta: {
        title: '管理员-广告主管理',
        icon: 'el-icon-set-up',
        roles: [
          'advertiser_users.index'
        ]
      }
    },
    {
      path: '/adminAdvertMangement/platform/index',
      component: () => {
        return import('@/views/providerAccountManagement/platform/index.vue')
      },
      name: 'AccountPlatform',
      meta: {
        title: '平台',
        icon: 'el-icon-set-up',
        roles: [
          'platforms.index'
        ]
      }
    },
    {
      path: '/adminAdvertMangement/fanqiePlayAccount/platform/index',
      component: () => {
        return import('@/views/providerAccountManagement/fanqie/index.vue')
      },
      name: 'fanqiePlayAccount',
      meta: {
        title: '番茄短剧账号',
        icon: 'el-icon-set-up',
        roles: [
          'changdu_playlet_account'
        ]
      }
    }
  ]
}

export default route
